import { PageHeader } from "@/components/ui/PageHeader";
import LogoutButton from "./LogoutButton";
import UserBasics from "./UserBasics";
import { EmailNotifications } from "./preferences/EmailNotifications";
import UserPreferences from "./preferences/UserPreferences";

function UserSettings() {
  return (
    <div className="flex flex-col h-full">
      <PageHeader header="User settings" />
      <div className="h-full flex flex-col space-y-6">
        <UserBasics />
        <UserPreferences />
        <EmailNotifications />

        <LogoutButton />
      </div>
    </div>
  );
}

export default UserSettings;
